/* eslint-disable */
import Swiper, { Navigation, Pagination, Autoplay } from "swiper";
import "swiper/swiper-bundle.css";

Swiper.use([Navigation, Pagination]);

const loadSwiper = () => {
  const swiper = new Swiper(".swiper", {
    slidesPerView: 1,
    spaceBetween: 10,
    responsive: true,
    observer: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      type: "bullets",
    },
    breakpoints: {
      570: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: "auto",
        spaceBetween: 0,
      },
    },
  });
};

const swiperPhoto = () => {
  const swiper = new Swiper(".swiperPhoto", {
    slidesPerView: 1,
    spaceBetween: 10,
    responsive: true,
    observer: true,
    loop: true,
    modules: [Autoplay],
    autoplay: {
      delay: 4000,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
  });
};

const swiperLogo = () => {
  const swiper = new Swiper(".swiperLogo", {
    slidesPerView: 3,
    spaceBetween: 10,
    responsive: true,
    observer: true,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      type: "bullets",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    modules: [Autoplay],
    autoplay: {
      delay: 4000,
    },
    breakpoints: {
      450: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
      1366: {
        slidesPerView: 5,
        spaceBetween: 30,
      },
    },
  });
};

const swiperTestimonials = () => {
  const swiper = new Swiper(".swiper-container", {
    spaceBetween: 1,
    slidesPerView: 1,
    centeredSlides: true,
    roundLengths: true,
    loop: true,
    direction: "vertical",
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    modules: [Autoplay],
    autoplay: {
      delay: 8000,
    },
  });
};

const swiperMember = () => {
  let init = false;
  if (window.innerWidth <= 1024) {
    if (!init) {
      init = true;
      const swiper = new Swiper(".swiper-member", {
        spaceBetween: 1,
        slidesPerView: 1,
        observer: true,
        centeredSlides: true,
        roundLengths: true,

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        modules: [Autoplay],
        breakpoints: {
          550: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
          850: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
        },
      });
    }
  } else if (init) {
    swiper.destroy();
    init = false;
  }
};

window.addEventListener("load", swiperTestimonials);
window.addEventListener("load", loadSwiper);
window.addEventListener("load", swiperPhoto);
window.addEventListener("load", swiperLogo);
window.addEventListener("load", swiperMember);
